import Cookies from 'js-cookie'

const CL_COOKIE_NAME = import.meta.env.PUBLIC_CL_COOKIE_NAME || 'account'
const CL_COOKIE_PATH = '/'
const CL_COOKIE_DOMAIN = import.meta.env.PUBLIC_CL_COOKIE_DOMAIN || ''

export const getTokenCookie = (cookieName: string): string | undefined => Cookies.get(cookieName)

export const setTokenCookie = (cookieName: string, value: string, options = {}): void => {
  Cookies.set(cookieName, value, { path: CL_COOKIE_PATH, domain: CL_COOKIE_DOMAIN, ...options })
}

export const removeTokenCookie = (options = {}): void => {
  Cookies.remove(CL_COOKIE_NAME, { path: CL_COOKIE_PATH, domain: CL_COOKIE_DOMAIN, ...options })
}
